import {toAsterisk, toExpirationDate} from '@yandex-delivery/core/formatters'
import {flow, get, map, toLower} from '@yandex-delivery/utils'

import {CardSystem, isKnownCardSystem, PaymentCard} from '../../../model/payment'
import {EmployeeCardToBoundListResponse, PaymentMethod} from '../../../repo/cargo-corp/types'

const toSystem: (p: PaymentMethod) => CardSystem = flow(
  get('system'),
  toLower,
  function _toSystem(system?: string): CardSystem {
    if (system && isKnownCardSystem(system)) {
      return system
    }

    return 'unknown'
  },
)

function toCard(paymentMethod: PaymentMethod): PaymentCard {
  return {
    __type: 'card',
    id: 'card_id' in paymentMethod ? paymentMethod.card_id : paymentMethod.id,
    system: toSystem(paymentMethod),
    number: toAsterisk(paymentMethod.number),
    expirationDate: toExpirationDate(paymentMethod.expiration_year, paymentMethod.expiration_month),
  }
}

export const toCards: (response: EmployeeCardToBoundListResponse) => PaymentCard[] = flow(
  get('available_cards'),
  map(toCard),
)
